<app-header #headerComponent [$userLoggedIn]="$user" [activeMenu]="$activeMenu | async" [menuList]="logoMenuList"
            (outMenuClicked)="menuClicked($event)"></app-header>
<!--TODO: Remove quickfix about show faq in PROD-->
<div class="content" [style.padding]="isFaq ? '30px': '0px'">
  <router-outlet></router-outlet>
</div>

<button *ngIf="$showScrollButton | async" class="floating-button" (click)="scrollTop()"><i class="icon-arrowup"></i>
</button>
